import React from "react";
import "./Preloader.css";
import logo from "../../Assets/Camera/Logo.svg";
const Preloader = () => {
  return (
    <div className="preloader-gradient">
      <svg
        id="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="26.7634"
        height="26.7634"
        viewBox="0 0 26.7634 26.7634"
      >
        <path d="M13.3817,0h0c0,7.3905-5.9912,13.3817-13.3817,13.3817h0c7.3905,0,13.3817,5.9912,13.3817,13.3817h0c0-7.3905,5.9912-13.3817,13.3817-13.3817h0c-7.3905,0-13.3817-5.9912-13.3817-13.3817Z" />
      </svg>
      <div className="name-container">
        <div className="logo-name">
          <img src={logo} alt="Augment.ing Logo" width="160" />
        </div>
      </div>
    </div>
  );
};

export default Preloader;
